/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProgressBar({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/ProgressBarIndicator/ProgressBar"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let widgetSettingsShowprogressbarValueData = fromData.useDataFormat({ viewPath,
context: 'widget',
path: 'settings.showProgressBar',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(widgetSettingsShowprogressbarValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}